import { Layer } from '../../types'
import { useQueryParams } from 'hooks/useQueryParams'
import { CleanupModeActions } from '../../stores/CleanupMode'
import { LayerMergeCompleteMessage } from './LayerMergeCompleteMessage'
import { LayerDeleteCompleteMessage } from './LayerDeleteCompleteMessage'

interface Props {
  layer: Layer
}

export const LayerCompleteMessage = ({ layer }: Props) => {
  const { cleanupAction } = useQueryParams()

  return cleanupAction === CleanupModeActions.Merge ? (
    <LayerMergeCompleteMessage layer={layer} />
  ) : (
    <LayerDeleteCompleteMessage layer={layer} />
  )
}
